module.exports = __webpack_public_path__ + "images/directory/icons/notCompliant.f6693799e8236f50455b.svg";